import React, { useState } from 'react';
import { FaWhatsapp, FaTwitter, FaFacebook, FaCopy, FaDownload, FaPrint } from 'react-icons/fa';

export default function ShareReading({ title, content, type }) {
  const [copied, setCopied] = useState(false);

  const shareText = `${title}\n\n${content.substring(0, 500)}...\n\n✨ Generated by AstroA2Z - Your AI Astrologer`;
  const shareUrl = window.location.href;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(`${title}\n\n${content}\n\n🔮 AstroA2Z`);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const handleWhatsApp = () => {
    const text = encodeURIComponent(shareText);
    window.open(`https://wa.me/?text=${text}`, '_blank');
  };

  const handleTwitter = () => {
    const text = encodeURIComponent(`${title}\n\n✨ Check out my reading from AstroA2Z!`);
    window.open(`https://twitter.com/intent/tweet?text=${text}&url=${encodeURIComponent(shareUrl)}`, '_blank');
  };

  const handleFacebook = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&quote=${encodeURIComponent(title)}`, '_blank');
  };

  const handleDownload = () => {
    const blob = new Blob([`${title}\n\n${content}\n\n---\nGenerated by AstroA2Z`], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${type || 'reading'}-${new Date().toISOString().split('T')[0]}.txt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handlePrint = () => {
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <html>
        <head>
          <title>${title} - AstroA2Z</title>
          <style>
            body { font-family: Georgia, serif; max-width: 800px; margin: 40px auto; padding: 20px; line-height: 1.8; }
            h1 { color: #800020; border-bottom: 2px solid #d4a017; padding-bottom: 10px; }
            .content { white-space: pre-wrap; }
            .footer { margin-top: 40px; text-align: center; color: #666; font-size: 12px; }
          </style>
        </head>
        <body>
          <h1>🔮 ${title}</h1>
          <div class="content">${content}</div>
          <div class="footer">Generated by AstroA2Z • ${new Date().toLocaleDateString()}</div>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <div className="share-reading">
      <div className="share-buttons">
        <button className="share-btn whatsapp" onClick={handleWhatsApp} title="Share on WhatsApp">
          <FaWhatsapp />
        </button>
        <button className="share-btn twitter" onClick={handleTwitter} title="Share on Twitter/X">
          <FaTwitter />
        </button>
        <button className="share-btn facebook" onClick={handleFacebook} title="Share on Facebook">
          <FaFacebook />
        </button>
        <button className="share-btn copy" onClick={handleCopy} title="Copy to clipboard">
          <FaCopy />
          {copied && <span className="copied-badge">Copied!</span>}
        </button>
        <button className="share-btn download" onClick={handleDownload} title="Download as text">
          <FaDownload />
        </button>
        <button className="share-btn print" onClick={handlePrint} title="Print">
          <FaPrint />
        </button>
      </div>
    </div>
  );
}
